var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDownwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63087 6.82857L2.09312 3.68571C1.86499 3.40318 2.08203 3 2.46225 3H7.53775C7.91798 3 8.13501 3.40318 7.90688 3.68571L5.36913 6.82857C5.18456 7.05714 4.81544 7.05714 4.63087 6.82857Z",
    fill: "#C6D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDownwardIcon);
export default __webpack_public_path__ + "static/media/FolderDownwardIcon.fa7ef6cc949151cf1f9c2ad867482dc2.svg";
export { ForwardRef as ReactComponent };